module.exports = __webpack_public_path__ + "images/home/product/video-arrow-67faaff2bd0c7bb03e1093b5a87f3ebb.png";